// export const LIVE_LINK="http://192.168.250.135:8080"

export const LIVE_LINK = process.env.REACT_APP_LIVE_LINK;
console.log('LIVE LINK:', process.env.REACT_APP_LIVE_LINK);
//REGISTER
///test
export const CHECK_AUTH = `${LIVE_LINK}/private`;
//LOGIN
export const POST_LOGIN = `${LIVE_LINK}/auth/login`;
export const POST_FAKE_JWT_PASSWORD_FORGET = `${LIVE_LINK}/auth/forgotpassword`;
export const POST_FAKE_JWT_PASSWORD_RESET = `${LIVE_LINK}/auth/resetpassword`;
//PROFILE
export const UPDATE_USER_DATA = `${LIVE_LINK}/profile`;
export const UPDATE_MODE = `${LIVE_LINK}/profile/mode`;
export const EDIT_PHOTO = `${LIVE_LINK}/profile/photo`;
export const EDIT_PASSWORD = `${LIVE_LINK}/profile/editPwd`;
//DASHBOARD
export const GET_DASHBOARD_INFO = `${LIVE_LINK}/dash`;
export const GET_DASHBOARD_INFO_FILTER = `${LIVE_LINK}/dash/filter`;
export const GET_MEDIAN_AVERAGE = `${LIVE_LINK}/dash/med`;
//BATTLEFIELD
export const GET_BATTLE_INFO = `${LIVE_LINK}/battle`;
export const GET_SPEC_BATTLE = `${LIVE_LINK}/battle/ordersperiod`;
//PRIORITY
export const GET_PRIORITY_INFO = `${LIVE_LINK}/priority`;
export const GET_ARCHIVE_PR = `${LIVE_LINK}/priority/archive`;
export const GET_SPEC_PR = `${LIVE_LINK}/priority/ordersperiod`;
export const GET_HISTORY = `${LIVE_LINK}/priority/history`;
//USERS
export const GET_USERS = `${LIVE_LINK}/users`;
export const ADD_USER = `${LIVE_LINK}/users`;
export const UPDATE_USER = `${LIVE_LINK}/users`;
export const DELETE_USER = `${LIVE_LINK}/users`;
//DEPARTMENTS
export const GET_DEPARTMENTS = `${LIVE_LINK}/departments`;
export const ADD_DEPARTMENT = `${LIVE_LINK}/departments`;
export const UPDATE_DEPARTMENT = `${LIVE_LINK}/departments`;
export const DELETE_DEPARTMENT = `${LIVE_LINK}/departments`;
//DOMAINS
export const GET_DOMAINS = `${LIVE_LINK}/domains`;
export const GET_CREDENTIALS = `${LIVE_LINK}/domains/credentials`;
export const ADD_DOMAIN = `${LIVE_LINK}/domains`;
export const UPDATE_DOMAIN = `${LIVE_LINK}/domains`;
export const DELETE_DOMAIN = `${LIVE_LINK}/domains`;
//SUBSCRIPTIONS
export const GET_SUBS = `${LIVE_LINK}/domains/sub`;
export const ADD_SUB = `${LIVE_LINK}/domains/sub`;
export const UPDATE_SUB = `${LIVE_LINK}/domains/sub`;
export const DELETE_SUB = `${LIVE_LINK}/domains/sub`;
//CUSTOMER SERVICE
export const GET_CUSTOMER_SERVICE = `${LIVE_LINK}/cust-service`;
export const ADD_NEW_CUSTOMER_SERVICE = `${LIVE_LINK}/cust-service`;
export const UPDATE_CUSTOMER_SERVICE = `${LIVE_LINK}/cust-service`;
export const DELETE_CUSTOMER_SERVICE = `${LIVE_LINK}/cust-service`;
//CALCULATOR
export const GET_MOSCOW_DATA = `${LIVE_LINK}/calcRight7`;
export const GET_SHIPPING_DATA = `${LIVE_LINK}/calculator`;
export const ADD_BOX_SIZE = `${LIVE_LINK}/calculator/boxSize`;
export const UPDATE_BOX_SIZE = `${LIVE_LINK}/calculator/boxSize`;
export const DELETE_BOX_SIZE = `${LIVE_LINK}/calculator/boxSize`;
export const ADD_PRICE = `${LIVE_LINK}/calculator/price`;
export const UPDATE_PRICE = `${LIVE_LINK}/calculator/price`;
export const DELETE_PRICE = `${LIVE_LINK}/calculator/price`;
export const ADD_TAX_PRICE = `${LIVE_LINK}/calculator/taxPrice`;
export const UPDATE_TAX_PRICE = `${LIVE_LINK}/calculator/taxPrice`;
export const DELETE_TAX_PRICE = `${LIVE_LINK}/calculator/taxPrice`;
export const ADD_COUNTRIES_TR = `${LIVE_LINK}/calculator/countries`;
export const ADD_COUNTRIES = `${LIVE_LINK}/calculator/countriesCheapExp`;
//PRICE LIST
export const GET_PRICES_DATA = `${LIVE_LINK}/prices`;
export const ADD_PRICE_PRODUCT = `${LIVE_LINK}/prices`;
export const UPDATE_PRICE_PRODUCT = `${LIVE_LINK}/prices`;
export const DELETE_PRICE_PRODUCT = `${LIVE_LINK}/prices`;
export const UPDATE_RESPONSIBLE_REGION = `${LIVE_LINK}/prices/region`;
export const GET_FONT = `${LIVE_LINK}/prices/font`;
//PRICE INFO
export const ADD_INFO_DATA = `${LIVE_LINK}/prices/info`;
export const UPDATE_INFO_DATA = `${LIVE_LINK}/prices/info`;
export const DELETE_INFO_DATA = `${LIVE_LINK}/prices/info`;
// export const GET_INFO_DATA = `${LIVE_LINK}/prices/info`;

// export const GET_CAT_PRODUCTS_DATA = `${LIVE_LINK}/prices/cat_product`;
// export const GET_ACCESS_DATA = `${LIVE_LINK}/prices/acs`;
// export const GET_PRODUCTS_DATA = `${LIVE_LINK}/prices/def`;
// export const GET_REG_PRODUCTS_DATA = `${LIVE_LINK}/prices/regs`;

// export const GET_REGION_INFO = `${LIVE_LINK}/prices/reg`;
// export const ADD_PRICE_DATA_REGION = `${LIVE_LINK}/prices/region`;

//MEETINGS
export const GET_MEETING_INFO = `${LIVE_LINK}/meeting`;
export const ADD_MEETING = `${LIVE_LINK}/meeting`;
export const UPDATE_MEETING = `${LIVE_LINK}/meeting`;
export const DELETE_MEETING = `${LIVE_LINK}/meeting`;
//LOST ORDERS
export const GET_LOST_ORDERS_INFO = `${LIVE_LINK}/lost`;
// export const ADD_LOST_ORDER = `${LIVE_LINK}/lost`;
// export const UPDATE_LOST_ORDER = `${LIVE_LINK}/lost`;
// export const DELETE_LOST_ORDER = `${LIVE_LINK}/lost`;
//ACTIVIDAN SHIPPING
export const GET_ACT_SHIPPING = `${LIVE_LINK}/act`;
export const ADD_ACT_SHIPPING = `${LIVE_LINK}/act`;
export const UPDATE_ACT_SHIPPING = `${LIVE_LINK}/act`;
export const DELETE_ACT_SHIPPING = `${LIVE_LINK}/act`;
// STATS
export const GET_NEW_CLIENTS = `${LIVE_LINK}/statistics/new_clients`;
export const GET_SELECTED_NEW_CLIENTS = `${LIVE_LINK}/statistics/selected_clients`;
// TRANSFERS
export const GET_TRANSFERS_INFO = `${LIVE_LINK}/transfers`;
export const GET_STATUS_TRANSFER = `${LIVE_LINK}/transfers/status`;
export const GET_COMPLETED_TRANSFER = `${LIVE_LINK}/transfers/completed`;
export const GET_FILTERED_TRANSFERS_MOSCOW = `${LIVE_LINK}/transfers/filtered`;
export const GET_AGENTS_INFO = `${LIVE_LINK}/transfers/agents`;
export const ADD_AGENT = `${LIVE_LINK}/transfers/agents`;
export const UPDATE_AGENT = `${LIVE_LINK}/transfers/agents`;
export const DELETE_AGENT = `${LIVE_LINK}/transfers/agents`;
//TRANSFERS MOSCOW
export const GET_TRANSFERS_MOSCOW = `${LIVE_LINK}/transfers/transfer-moscow`;
export const GET_TRANSFERS_MOSCOW_LIST = `${LIVE_LINK}/transfers/transfer-moscow`;
export const ADD_TRANSFER_MOSCOW = `${LIVE_LINK}/transfers/transfer-moscow`;
export const UPDATE_TRANSFER_MOSCOW = `${LIVE_LINK}/transfers/transfer-moscow`;
export const DELETE_TRANSFER_MOSCOW = `${LIVE_LINK}/transfers/transfer-moscow`;
//TRANSFERS MOSCOW
export const GET_TRANSFERS_PRIORITY = `${LIVE_LINK}/transfers/priority-moscow`;
export const ADD_TRANSFER_PRIORITY = `${LIVE_LINK}/transfers/priority-moscow`;
export const UPDATE_TRANSFER_PRIORITY = `${LIVE_LINK}/transfers/priority-moscow`;
export const DELETE_TRANSFER_PRIORITY = `${LIVE_LINK}/transfers/priority-moscow`;

export const GET_TRANSFERS_SHIPPING = `${LIVE_LINK}/transfers/transfer-shipping`;
export const UPDATE_TRANSFER_MOSCOW_DATA = `${LIVE_LINK}/transfers/transfer-shipping`;
export const DELETE_TRANSFER_SHIPPING = `${LIVE_LINK}/transfers/transfer-shipping`;
//PURCHASES
export const GET_ARRIVED_PURCHASES = `${LIVE_LINK}/purchases/arrived`;
export const GET_ARRIVED_PRODUCTS = `${LIVE_LINK}/purchases/completed`;
export const GET_PURCHASES_INFO = `${LIVE_LINK}/purchases`;
export const ADD_PRODUCT = `${LIVE_LINK}/purchases/product`;
export const UPDATE_PRODUCT = `${LIVE_LINK}/purchases/product`;
export const DELETE_PRODUCT = `${LIVE_LINK}/purchases/product`;
export const ADD_PURCHASE = `${LIVE_LINK}/purchases/purchase`;
export const UPDATE_PURCHASE = `${LIVE_LINK}/purchases/purchase`;
export const DELETE_PURCHASE = `${LIVE_LINK}/purchases/purchase_del`;
// socket link
